import PageHeader from '../Components/PageHeader'
import { useLocation, } from 'react-router-dom'

const TeamDetails = () => {
    const location = useLocation();
    const allData = location ? location.state : '';

    return (
        <>
            {allData ?
                <section className='history_of_osa'>
                    <div className="about_osa_layer">
                        <PageHeader heading={allData.name} subheading="Our Team" link="/our_team" />
                        <div className="about_main_container">
                            <div className="container">
                                {allData ?
                                    <>
                                        <div className="row">
                                            <div className="col-md-5">
                                                <div className="newsdetails_img">
                                                    <img src={allData?.image_url} alt="" />
                                                </div>
                                            </div>
                                            <div className="col-md-7 pl-2 pt-4">
                                                <div className="aboutschool_text">
                                                    <h4 className='news_title '>{allData.name}</h4>
                                                    {allData?.designation ? <small className=''> <strong>Designation:</strong> {allData.designation}</small> : ''}<br />
                                                    {allData?.mobile ? <small className=''> <strong>Mobile:</strong> {allData.mobile}</small> : ''}<br />
                                                    {allData?.email ? <small className=''><strong> Email Id:</strong> {allData.email}</small> : ''}
                                                    {allData.about ? <div className="desc pt-4">  {allData.about}</div> : ''}
                                                </div>
                                            </div>
                                        </div>
                                        <br /><br />
                                    </>
                                    : ''}
                            </div>

                        </div>
                    </div>
                </section>
                : ''}
        </>
    )
}

export default TeamDetails
